/*  ========================================================================
    # Section - Quotes
    ========================================================================  */

import React, { useEffect, useState } from 'react';

const Quotes = ({ headline, entries }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  /**
   * Check if sliding to the left should be possible.
   */
  const canSlideLeft = () => {
    if (activeSlide === 0) return false;
    return true;
  };

  /**
   * Check if sliding to the right should be possible.
   */
  const canSlideRight = () => {
    if (activeSlide + 1 < entries.length) return true;
    return false;
  };

  /**
   * Handle slide to left.
   */
  const slideLeft = () => {
    if (canSlideLeft()) {
      setActiveSlide(prev => prev - 1);
    } else {
      setActiveSlide(entries.length - 1);
    }
  };

  /**
   * Handle slide to right.
   */
  const slideRight = () => {
    if (canSlideRight()) {
      setActiveSlide(prev => prev + 1);
    } else {
      setActiveSlide(0);
    }
  };

  /**
   * Set active slide index to 0 on window resize.
   */
  useEffect(() => {
    window.addEventListener(
      'resize',
      () => {
        setActiveSlide(0);
      },
      { passive: true }
    );
  }, []);

  return (
    <div className='p-landing__container'>
      <div className='s-quotes__headline'>
        <div className='p-landing__wysiwyg-block' dangerouslySetInnerHTML={{ __html: headline }} />
      </div>

      <div className='p-landing__row' style={{ '--active-slide': activeSlide }}>
        <div className='p-landing__col s-quotes__image-wrapper'>
          <div className='s-quotes__image-inner'>
            <svg
              className='s-quotes__marks'
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 123 76'
              fill='none'
            >
              <path
                d='M0 4C0 1.79086 1.79086 0 4 0H48.7143C50.9234 0 52.7143 1.79086 52.7143 4V72.0241C52.7143 73.0324 51.3911 73.4069 50.8626 72.5482L39.8286 54.6179C39.1006 53.4349 37.811 52.7143 36.422 52.7143H4C1.79086 52.7143 0 50.9234 0 48.7143V4Z'
                fill='#0068A6'
              />
              <path
                d='M70.2856 4C70.2856 1.79086 72.0765 0 74.2856 0H119C121.209 0 123 1.79086 123 4V72.0241C123 73.0324 121.677 73.4069 121.148 72.5482L110.114 54.6179C109.386 53.4349 108.097 52.7143 106.708 52.7143H74.2856C72.0765 52.7143 70.2856 50.9234 70.2856 48.7143V4Z'
                fill='#0068A6'
              />
            </svg>
            <div
              className='s-quotes__image-axis'
              style={{
                transform: 'translateX(calc((-100% / 1 * var(--active-slide)))'
              }}
            >
              {entries.map((entry, index) => (
                <figure
                  key={`image-${index}`}
                  className='s-quotes__image-entry'
                  style={{ opacity: index === activeSlide ? 1 : 0.2 }}
                >
                  <img src={entry.image.sizes.large} alt={entry.image.alt} />
                </figure>
              ))}
            </div>
            <div className='s-quotes__controls'>
              <button
                type='button'
                className='s-quotes__controls-button'
                onClick={() => slideLeft()}
              >
                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 14' fill='none'>
                  <path
                    d='M6.82849 1.34303L1.17163 6.99988L6.82849 12.6567'
                    stroke='#ffffff'
                    strokeWidth='1.5'
                  />
                </svg>
              </button>
              <div className='s-quotes__controls-dots'>
                {entries.map((entry, index) => (
                  <span
                    key={`dot-${index}`}
                    style={{ backgroundColor: index === activeSlide ? '#0068a6' : '#d8e3eb' }}
                    onClick={() => setActiveSlide(index)}
                  />
                ))}
              </div>
              <button
                type='button'
                className='s-quotes__controls-button'
                onClick={() => slideRight()}
              >
                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 14' fill='none'>
                  <path
                    d='M1.17151 1.34303L6.82837 6.99988L1.17151 12.6567'
                    stroke='#ffffff'
                    strokeWidth='1.5'
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className='p-landing__col s-quotes__content-wrapper'>
          <div className='s-quotes__content-inner'>
            <div
              className='s-quotes__content-axis'
              style={{
                transform: 'translateX(calc((-100% / 1 * var(--active-slide)))'
              }}
            >
              {entries.map((entry, index) => (
                <div
                  key={`content-${index}`}
                  className='s-quotes__content-entry'
                  style={{ opacity: index === activeSlide ? 1 : 0.2 }}
                >
                  <figure>
                    <img src={entry.logo.sizes.medium} alt={entry.logo.alt} />
                  </figure>
                  <blockquote>{entry.text}</blockquote>
                  <p dangerouslySetInnerHTML={{ __html: entry.customer }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quotes;
